const hasSomeData = data => typeof data !== 'undefined';

export { hasSomeData };
//# sourceMappingURL=validators.js.map
